var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOximeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.226 128.258H175.323V119.726C175.323 106.75 164.766 96.194 151.791 96.194H87.661C74.685 96.194 64.129 106.751 64.129 119.726V128.258H23.532C10.557 128.258 0 138.814 0 151.79V392.274C0 405.25 10.557 415.806 23.532 415.806H368.226C447.503 415.807 512 351.31 512 272.032C512 192.754 447.503 128.258 368.226 128.258V128.258ZM79.129 119.726C79.129 115.022 82.957 111.194 87.661 111.194H151.79C156.495 111.194 160.322 115.022 160.322 119.726V128.258H79.129V119.726ZM368.226 400.807H23.532C18.827 400.807 15 396.979 15 392.275V151.79C15 147.085 18.828 143.258 23.532 143.258H368.226C439.232 143.258 497 201.026 497 272.032C497 343.038 439.232 400.807 368.226 400.807Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.208 160.322H344.179C340.037 160.322 336.679 163.68 336.679 167.822C336.679 171.965 340.037 175.322 344.179 175.322H360.208C364.913 175.322 368.74 179.15 368.74 183.854V264.532H317.189L303.043 229.166C301.817 226.103 298.735 224.202 295.445 224.478C292.157 224.757 289.438 227.153 288.746 230.379L271.898 309.004L247.288 198.259C246.534 194.863 243.543 192.432 240.065 192.386C236.59 192.348 233.534 194.692 232.69 198.067L207.586 298.483L191.089 237.993C190.271 234.993 187.687 232.809 184.592 232.503C181.49 232.193 178.534 233.832 177.145 236.612L163.186 264.53H111.192V183.852C111.192 179.148 115.02 175.32 119.724 175.32H312.111C316.253 175.32 319.611 171.963 319.611 167.82C319.611 163.678 316.253 160.32 312.111 160.32H119.725C106.749 160.32 96.1934 170.877 96.1934 183.852V360.21C96.1934 373.186 106.75 383.742 119.725 383.742H360.209C373.185 383.742 383.741 373.185 383.741 360.21V183.854C383.741 170.879 373.184 160.322 360.208 160.322V160.322ZM360.208 368.742H119.725C115.02 368.742 111.193 364.914 111.193 360.21V279.532H167.822C170.663 279.532 173.26 277.927 174.53 275.386L181.783 260.88L200.666 330.119C201.563 333.411 204.583 335.705 207.981 335.645C211.393 335.609 214.35 333.275 215.177 329.965L239.536 232.529L264.708 345.805C265.471 349.238 268.515 351.678 272.029 351.678H272.058C275.584 351.664 278.624 349.197 279.363 345.749L298.255 257.588L305.147 274.817C306.286 277.665 309.043 279.532 312.11 279.532H368.739V360.21C368.741 364.914 364.913 368.742 360.208 368.742V368.742Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6289 200.403C67.4869 200.403 64.1289 203.761 64.1289 207.903V336.161C64.1289 340.304 67.4869 343.661 71.6289 343.661C75.7709 343.661 79.1289 340.304 79.1289 336.161V207.903C79.1289 203.761 75.7709 200.403 71.6289 200.403Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M478.689 262.148C477.657 258.136 473.568 255.723 469.557 256.754C465.546 257.787 463.13 261.875 464.163 265.886C464.676 267.88 464.936 269.948 464.936 272.032C464.936 285.577 453.916 296.596 440.372 296.596C426.828 296.596 415.808 285.576 415.808 272.032C415.808 258.488 426.828 247.468 440.372 247.468C442.469 247.468 444.549 247.731 446.554 248.25C450.561 249.288 454.656 246.879 455.695 242.869C456.733 238.859 454.324 234.767 450.314 233.729C447.082 232.892 443.737 232.468 440.373 232.468C418.557 232.468 400.809 250.217 400.809 272.032C400.809 293.847 418.558 311.596 440.373 311.596C462.188 311.596 479.937 293.847 479.937 272.032C479.936 268.688 479.516 265.362 478.689 262.148V262.148Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 256,
    y1: 96.194,
    x2: 256,
    y2: 415.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 239.967,
    y1: 160.32,
    x2: 239.967,
    y2: 383.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 71.6289,
    y1: 200.403,
    x2: 71.6289,
    y2: 343.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 440.373,
    y1: 232.468,
    x2: 440.373,
    y2: 311.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOximeter);
export default __webpack_public_path__ + "static/media/oximeter.5203b086d3ed044b56adb0f41fddda7e.svg";
export { ForwardRef as ReactComponent };